import Vue from 'vue'
import {
	Swipe,
	SwipeItem,
	Lazyload,
	Switch,
	Field,
	CellGroup,
	Overlay,
	SwipeCell,
	PullRefresh,
	Loading,
	Form,
	Slider
} from 'vant'
import WebToApp from '@nio-fe/web-to-app'
import App from './App.vue'
import router, { currentPage } from './routes'
import store from './store/index'
import util from '@/util/util'
import { taskMgr } from '@/supreme-core'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import link from '@/util/link'
import nativeHybrid, { initNativeAsyncData } from '@/util/nativeHybrid'
import SensorsVue from '@/util/sensors-vue'
import NioAppUi from '@nio-fe/nio-app-ui'
import { applyLocaleMode } from '@nio-fe/nio-app-ui/lib/style'
import { use } from '@nio-fe/nio-app-ui/es/locale'
import uiLabelsCN from '@nio-fe/nio-app-ui/es/locale/lang/zh-CN'
import '@nio-fe/nio-app-ui/lib/index.css'
import VConsole from 'vconsole'
import PortalVue from 'portal-vue'
import { initApmPlus } from '@/apmPlus'

// 生产环境捕获报错
if (process.env.NODE_ENV === 'production') {
	try {
		Sentry.init({
			dsn: util.getEnvInfo().sentryUrl,
			environment: util.getEnvStr(),
			integrations: [new Integrations.Vue({ Vue, attachProps: true })]
		})
		// eslint-disable-next-line no-empty
	} catch (err) {}
}

if (util.getEnv() < 3) {
	new VConsole()
}

// 埋点
Vue.use(SensorsVue)

Vue.use(NioAppUi)
Vue.use(PortalVue)
applyLocaleMode('cn')
use(uiLabelsCN)

Vue.use(WebToApp, {
	globalComponents: ['download-banner', 'wx-guide'],
	// 注册全局指令，如不需要可以不传入该参数
	globalDirectives: ['v-open-launch-app']
})
// 注册组件
Vue.use(Swipe)
	.use(Slider)
	.use(SwipeItem)
	.use(Switch)
	.use(Form)
	.use(Field)
	.use(CellGroup)
	.use(Overlay)
	.use(SwipeCell)
	.use(PullRefresh)
	.use(Loading)
// 注册图片懒加载组件
Vue.use(Lazyload, {
	preLoad: 1.3,
	loading: require('./assets/images/placeholder@2x.png'),
	error: require('./assets/images/placeholder@2x.png'),
	attempt: 1
})

Vue.config.productionTip = false

Vue.prototype.$isInWebview = util.isInWebview()

initApmPlus(Vue)

const renderFn = async () => {
	if (nativeHybrid.isWeapp()) {
		await new Promise(resolve => {
			const $script = document.createElement('script')
			$script.src = 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js'
			$script.onload = resolve
			document.body.appendChild($script)
		})
	} else {
		await new Promise(resolve => setTimeout(resolve, 200))
	}
	if (util.isInWebview()) {
		nativeHybrid.showLoading()
	}

	await initNativeAsyncData()

	new Vue({
		router,
		store,
		render: h => h(App)
	}).$mount('#app')

	// 注册App webview事件
	if (util.isInWebview()) {
		nativeHybrid.registerAppear()
	}
}
renderFn()
